<div class="addfrom-wrapper">
  <app-thumbnail-gallery [sourceCards]="cardsToSelect" [disabledCards]="disableForSelectCards" [galleryMode]="GALLERY_MODE.SELECTION" (cardClicked)="onCardSelected($event)" (cardPriceTagClicked)="onCardSelected($event)" class="low-margin-title last-slider"
  [ngClass]="{'single-select': singleSelectMode}"></app-thumbnail-gallery>
</div>
<div class="background-overlay dark-background-overscroll"></div>
